<section class="simple-usp simple-usp--{{ theme() }}">
  <div class="container">
    <ul
      class="simple-usp--list py-2 py-lg-4 mb-0"
      [attr.usps]="showUsp4() ? FOUR_USPS : THREE_USPS"
      aria-label="Lijst van unieke verkoopargumenten"
    >
      <li>
        <crnt-icon icon="check" class="me-2 simple-usp--list-icon" />
        <span *scText="usp1()"></span>
      </li>
      <li>
        <crnt-icon icon="check" class="me-2 simple-usp--list-icon" />
        <span *scText="usp2()"></span>
      </li>
      <li>
        <crnt-icon icon="check" class="me-2 simple-usp--list-icon" />
        <span *scText="usp3()"></span>
      </li>
      @if (showUsp4()) {
        <li>
          <crnt-icon icon="check" class="me-2 simple-usp--list-icon" />
          <span *scText="usp4()!"></span>
        </li>
      }
    </ul>
  </div>
</section>
